module.exports = __webpack_public_path__ + "img/menu-button.7ddf5b7f.svg";